import { useQuery } from '@tanstack/react-query';
import { individualsService, companiesService } from '@aslanpay/portal-common-lib';

import { EmployeeSearchResult } from 'app/components/CommandPalette/types';

const useSearchEmployees = (query: string, enabled = true) => {
  return useQuery<EmployeeSearchResult[], Error>(
    ['searchEmployees', query],
    async () => {
      if (!query || query.length < 3) {
        return [];
      }

      const employees = await individualsService.fetchIndividuals({
        role: ['EMPLOYEE'],
        query,
        page: 0,
        size: 20, // Limit to 20 results for command palette
      });

      // Fetch company names for the employees
      const companyIds = [...new Set(employees.list.map((emp) => emp.companyId))];
      const companies =
        companyIds.length > 0
          ? await companiesService.fetchCompanies({
              ids: companyIds,
              page: 0,
              size: companyIds.length,
            })
          : { list: [] };

      return employees.list.map((employee) => ({
        id: employee.id,
        companyId: employee.companyId,
        firstName: employee.firstName || '',
        lastName: employee.lastName || '',
        email: employee.email,
        companyName: companies.list.find((c) => c.id === employee.companyId)?.name,
        status: employee.status,
      }));
    },
    {
      enabled: enabled && query.length >= 3,
      staleTime: 30000, // Cache results for 30 seconds
      retry: false,
    }
  );
};

export default useSearchEmployees;
